import React from 'react';

const Header = () => (
  <header style={{ marginBottom: '20px', textAlign: 'left' }}>
    <h1 style={{ color: '#2D3E50', fontSize: '32px', fontWeight: '800' }}>
      MR Store Creator
    </h1>
    <p style={{ color: '#666', fontSize: '16px', fontWeight: '600' }}>
      Create and manage your MR stores
    </p>
  </header>
);

export default Header;